import { touchWebClient } from 'tradera/utils/http';

export const getReportItemModel = (itemId) => {
    return touchWebClient.get(`report-item/${itemId}.json`);
};

export const postReport = (itemId, reason, message, categoryId) => {
    const payload = { reason, message, categoryId };
    return touchWebClient.post(`report-item/${itemId}`, payload);
};
